<template>
    <div>
        <div class="row mt-5">
            <div  class="col-md-10 offset-md-1">
                <div class="row">
                    <div :class="{'col-md-4' : MaxScale === 'Monitor' ,'col-md-6' : MaxScale === 'miniMonitor'}">
                        <p class="mt-5"></p>
                        <b-link class="font-footer text-white mb-2 pt-5 h5" href="https://muic.mahidol.ac.th/eng/"><i class="fa fa-university mr-2" aria-hidden="true"></i>Mahidol University International College</b-link>
                        <h5 class="font-footer text-white mb-2 mt-2">
                            <i class="fa fa-map-marker mr-1" aria-hidden="true"></i>999 Phutthamonthon 4 Rd,, Salaya,
                            Phutthamonthon, Nakhon Pathom 73170
                            THAILAND
                        </h5>
                        <h6 class="font-footer text-white mb-2 mt-2"><i class="fa fa-phone-square mr-1" aria-hidden="true"></i>Telephone: +66 (0) 2700 5000</h6>
                        <h6 class="font-footer text-white mb-0 mt-1"><i class="fa fa-mobile mr-1" aria-hidden="true"></i>Mobile Call Center 098 269 0302</h6>
                        <a href="mailto:icwww@mahidol.ac.th">
                            <h6 class="font-footer text-white mb-2 mt-1"><i class="fa fa-envelope-o mr-1" aria-hidden="true"></i>E-mail icwww@mahidol.ac.th</h6>
                        </a>
                    </div>
                    <div :class="{'col-md-6' : MaxScale === 'Monitor' ,'col-md-6' : MaxScale === 'miniMonitor'}">
                        <p class="mt-5"></p>
                        <p class="mt-1 mb-1">
                            <b-link class="font-footer text-white" href="https://www.facebook.com/mahidol.inter" target="_blank">
                                <i class="fa fa-facebook-square mr-1" aria-hidden="true"></i>Join us on Facebook
                            </b-link>
                        </p>
                        <p class="mt-1 mb-1">
                            <b-link class="font-footer text-white" href="https://twitter.com/NewsMUIC" target="_blank">
                                <i class="fa fa-twitter-square mr-1" aria-hidden="true"></i>Twitter for students
                            </b-link>
                        </p>
                        <p class="mt-1 mb-1">
                            <b-link class="font-footer text-white" href="https://www.instagram.com/mahidol_inter/" target="_blank">
                                <i class="fa fa-instagram mr-1" aria-hidden="true"></i>Follow us on Instagram
                            </b-link>
                        </p>
                        <p class="mt-1 mb-1">
                            <b-link class="font-footer text-white" href="https://www.youtube.com/user/muictube" target="_blank">
                                <i class="fa fa-youtube-play mr-1" aria-hidden="true"></i>Watch us on Youtube
                            </b-link>
                        </p>
                        <p class="mt-1 mb-5">
                            <span class="text-white"><i class="fa fa-weixin mr-1" aria-hidden="true"></i>Line @MYMUIC</span>
                            <a rel="noopener noreferrer" target="_blank" class="mr-2" href="https://lin.ee/rMSY9VY">
                                <img class="ml-3" src="https://scdn.line-apps.com/n/line_add_friends/btn/en.png" alt="add" height="30" border="0">
                            </a>
                        </p>
                    </div>
                    <div :class="{'col-md-2' : MaxScale === 'Monitor' ,'col-md-6' : MaxScale === 'miniMonitor'}"></div>
                </div>
            </div>
        </div>
        <em class="text-white">Ver.1.0.3</em>
    </div>
</template>

<script>
    export default {
        props: {
            MaxScale:String,
        },   
    }
</script>

<style lang="scss" scoped>
    .font-footer{ font-family: 'Baloo Tamma 2', cursive; text-transform:none; font-weight: 100;}
</style>